import styled from 'styled-components';

import MuiPaper from '@mui/material/Paper';

export const Container = styled.div`
  display: grid;
  gap: 8px;
`;

export const Input = styled.input`
  display: none;
`;

export const InputLabel = styled.label``;

export const NoImage = styled(MuiPaper)`
  width: 100%;
  height: 200px;
  margin-bottom: ${({ theme }) => theme.spacing(1)};

  display: flex;
  align-items: center;
  justify-content: center;
`;
